<template>
	<div>
		<draggable v-model="list" item-key="Id" handle=".handle" ghost-class="ghost-drag">
			<template #item="{ element }">
				<div class="is-grabbable handle">
					{{ element.Name }}
				</div>
			</template>
		</draggable>
	</div>
</template>
<script>
	import { ref } from "vue";
	import draggable from "vuedraggable";

	export default {
		components: { draggable },
		props: {
			modelValue: {
				type: Array,
				default: () => {
					return [];
				}
			}
		},
		setup(props, context) {
			const list = ref(props.modelValue);

			return {
				list
			};
		}
	};
</script>